import script from "./PopupReviewMediaList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewMediaList.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewMediaList.vue?vue&type=style&index=0&id=40d9fdd4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d9fdd4"]])

export default __exports__